export default __webpack_public_path__ + "static/media/empty-history.90b4b2ef.svg";